/* global EVENT_META, PAGE_META */

import ApplicationController from "application_controller.js";
import { Modal } from "bootstrap";

export default class extends ApplicationController {

  debug = false;

  connect() {
    this.log_function("connect");

    window.setMetadata(EVENT_META); //* EVENT_META is global

    this.modalInstance = new Modal(this.element);
    //* Defer show to next frame so the browser paints the fade (opacity:0) state first
    requestAnimationFrame(() => this.modalInstance.show());

    //* Store a reference to the bound CloseModal function so we can remove it later
    this.boundCloseModal = this.CloseModal.bind(this);
    this.element.addEventListener("hidden.bs.modal", this.boundCloseModal);
  }

  disconnect() {
    this.log_function("disconnect");

    this.modalInstance.hide();
    this.element.removeEventListener("hidden.bs.modal", this.boundCloseModal);
  }

  CloseModal() {
    this.log_function("CloseModal");

    window.setMetadata(PAGE_META); //* PAGE_META is global

    //* Fix the path in the browser
    const newUrl = "/" + window.location.search;
    history.pushState({}, "", newUrl);

    //* Remove the element from its parent node
    if (this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
  }
}
